import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBar from '@/pages/_partials/SearchBar';
import FoldersExplorer from './_partials/FoldersExplorer';

export default function Folders() {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');

    return (
        <div className="space-y-6 pb-[120px] md:pb-0">
            {/* G.E.D. Explorer - includes PageHeader with breadcrumb */}
            <FoldersExplorer searchQuery={searchQuery} />
        </div>
    );
}
